var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import DwellTimeInfo from './model/DwellTimeInfo';
import DwellPersistenceManager from './persistence/DwellPersistenceManager';
import { shouldEnableDwellLogging } from './DwellTimeUtil';
import { DwellLoggerFactory } from './dwell-logger/DwellLoggerFactory';
import { DwellLoggerType } from './dwell-logger/DwellLoggerType';
var DwellTimeManager = /** @class */ (function () {
    function DwellTimeManager() {
        var _this = this;
        this._resetInactivityIfNeeded = function () {
            if (_this._dwellSet.size === 0 && _this._dwellStack.length === 0) {
                _this._resetInactivity();
            }
        };
        this._resetInactivity = function () {
            _this._inactiveTime = 0;
            _this._inactivityIndex = -1;
        };
        this._fillInactivityInDwellStack = function (currInactivityIndex, inactiveDuration) {
            for (var i = 0; i <= currInactivityIndex; ++i) {
                var dwellObj = _this._dwellStack[i];
                if (dwellObj) {
                    dwellObj.inactivityTime += inactiveDuration;
                }
            }
        };
        this._addObjToDwellStack = function (obj) {
            _this._dwellStack.push(obj);
        };
        this._removeObjFromDwellStack = function (startIndex, endIndex) {
            if (startIndex > endIndex) {
                return;
            }
            _this._dwellStack.splice(startIndex, endIndex - startIndex + 1);
        };
        this._addPageIdToDwellSet = function (pageId) {
            _this._dwellSet.add(pageId);
        };
        this._removePageIdFromDwellSet = function (pageId) {
            _this._dwellSet.delete(pageId);
        };
        this._ifPagePresentInDwellStack = function (pageId) {
            return _this._dwellSet.has(pageId);
        };
        this._getDwellObjIndexFromStack = function (pageId) {
            return _this._dwellStack.findIndex(function (obj) { return obj.pageId === pageId; });
        };
        this._addCurrentStackInPersistence = function () {
            DwellPersistenceManager.storeDwellInDiskStorage(_this._dwellStack);
        };
        this.addDwellObject = function (pageId, impressionId, parentImpressionId, type, pageType, widgetType, widgetViewType, widgetTitle, widgetCategory, moduleId, contentType) {
            var dwellObj = new DwellTimeInfo(pageId, impressionId, parentImpressionId, type, pageType, widgetType, widgetViewType, widgetTitle, widgetCategory, moduleId, contentType);
            _this._addPageIdToDwellSet(pageId);
            _this._addObjToDwellStack(dwellObj);
        };
        this.removeDwellObject = function (pageIds, startIndex, endIndex) {
            _this._removeObjFromDwellStack(startIndex, endIndex);
            pageIds.forEach(function (pageId) {
                _this._removePageIdFromDwellSet(pageId);
            });
            _this._resetInactivityIfNeeded();
        };
        this.isPageInDwellStack = function (pageId) {
            return _this._ifPagePresentInDwellStack(pageId);
        };
        this.checkAndTriggerDwellTimeFDP = function (pageId) {
            if (_this._ifPagePresentInDwellStack(pageId)) {
                var dwellObjIndex = _this._getDwellObjIndexFromStack(pageId);
                if (dwellObjIndex >= 0) {
                    var lastIndex = _this._dwellStack.length - 1;
                    var endTime = Date.now();
                    var pageIdsToRemove = [];
                    for (var currIndex = lastIndex; currIndex >= dwellObjIndex; currIndex--) {
                        var dwellObj = _this._dwellStack[currIndex];
                        dwellObj.endTime = endTime;
                        _this._loggerFactory.logDwellInfo(dwellObj);
                        pageIdsToRemove.push(dwellObj.pageId);
                    }
                    _this.removeDwellObject(pageIdsToRemove, dwellObjIndex, lastIndex);
                }
            }
        };
        this._loggerFactory = new DwellLoggerFactory(DwellTimeManager.DWELL_LOGGER_TYPE);
        this._checkPreviouslyStoredDwell();
        this._setupVisibilityListeners();
        this._dwellStack = [];
        this._dwellSet = new Set();
        this._inactiveTime = 0;
        this._inactivityIndex = -1;
    }
    DwellTimeManager.getInstance = function () {
        if (!shouldEnableDwellLogging()) {
            return undefined;
        }
        if (!DwellTimeManager.instance) {
            DwellTimeManager.instance = new DwellTimeManager();
        }
        return DwellTimeManager.instance;
    };
    DwellTimeManager.prototype._setupVisibilityListeners = function () {
        var _this = this;
        if (!DwellTimeManager.IS_BROWSER) {
            return;
        }
        this._visibilityChangeHandler = function () {
            if (document.hidden) {
                if (_this._dwellStack.length > 0) {
                    _this._inactiveTime = Date.now();
                    _this._inactivityIndex = _this._dwellStack.length - 1;
                    _this._addCurrentStackInPersistence();
                }
            }
            else {
                if (_this._inactivityIndex >= 0) {
                    DwellPersistenceManager.clearPersistedDwellData();
                    var inactivityDuration = _this._inactiveTime > 0 ? Date.now() - _this._inactiveTime : 0;
                    _this._inactiveTime = 0;
                    if (inactivityDuration > 0) {
                        _this._fillInactivityInDwellStack(_this._inactivityIndex, inactivityDuration);
                    }
                    _this._inactivityIndex = -1;
                }
                if (_this._getCurrentPageIdCallback) {
                    var currentPageId = _this._getCurrentPageIdCallback();
                    if (currentPageId && _this._ifPagePresentInDwellStack(currentPageId)) {
                        _this.checkAndTriggerDwellTimeFDP(currentPageId);
                    }
                }
            }
        };
        this._beforeUnloadHandler = function () {
            if (_this._dwellStack.length > 0) {
                var endTime = Date.now();
                var pageIdsToRemove = [];
                for (var currIndex = _this._dwellStack.length - 1; currIndex >= 0; currIndex--) {
                    var dwellObj = _this._dwellStack[currIndex];
                    dwellObj.endTime = endTime;
                    _this._loggerFactory.logDwellInfo(dwellObj);
                    pageIdsToRemove.push(dwellObj.pageId);
                }
                _this._dwellStack = [];
                _this._dwellSet.clear();
                _this._resetInactivity();
                _this._addCurrentStackInPersistence();
            }
        };
        document.addEventListener('visibilitychange', this._visibilityChangeHandler);
        window.addEventListener('beforeunload', this._beforeUnloadHandler);
    };
    DwellTimeManager.prototype._cleanupListeners = function () {
        if (DwellTimeManager.IS_BROWSER && this._visibilityChangeHandler) {
            document.removeEventListener('visibilitychange', this._visibilityChangeHandler);
        }
        if (typeof window !== 'undefined' && this._beforeUnloadHandler) {
            window.removeEventListener('beforeunload', this._beforeUnloadHandler);
        }
    };
    DwellTimeManager.prototype._checkPreviouslyStoredDwell = function () {
        return __awaiter(this, void 0, Promise, function () {
            var dwellObjects;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, DwellPersistenceManager.getDwellEventsFromPersistence()];
                    case 1:
                        dwellObjects = _a.sent();
                        if (dwellObjects && Array.isArray(dwellObjects) && dwellObjects.length > 0) {
                            dwellObjects.forEach(function (dwellObj) {
                                _this._loggerFactory.logDwellInfo(dwellObj);
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DwellTimeManager.prototype.setCurrentPageIdCallback = function (callback) {
        this._getCurrentPageIdCallback = callback;
    };
    DwellTimeManager.prototype.logDwellTimeIfAvailable = function (pageId) {
        if (!pageId) {
            return;
        }
        if (this._ifPagePresentInDwellStack(pageId)) {
            this.checkAndTriggerDwellTimeFDP(pageId);
        }
    };
    DwellTimeManager.DWELL_LOGGER_TYPE = DwellLoggerType.FDP;
    DwellTimeManager.IS_BROWSER = typeof document !== 'undefined';
    DwellTimeManager.handleJSCrashInDwell = function () {
        var _a;
        (_a = DwellTimeManager.getInstance()) === null || _a === void 0 ? void 0 : _a._addCurrentStackInPersistence();
    };
    return DwellTimeManager;
}());
export default DwellTimeManager;
